import { HttpResponse } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { MenuItem } from 'primeng/api'
import { BasicItemResult } from '../models/interfaces/basic-item-result.interface'

@Injectable({
   providedIn: 'root',
})
export class UtilityService {
   public downloadFile(response: HttpResponse<Blob>) {
      if (!response.body) {
         console.error('cannot download empty body response')
         return
      }

      let type = response.headers.get('content-type') ?? 'application/json'

      // Regex che gestisce sia filename="dummy.pdf" che filename=file.xlsx
      const contentDisposition = response.headers.get('content-disposition')
      const filenameMatch = contentDisposition?.match(/filename="?([^";\n]+)"?/)
      let fileName = filenameMatch?.[1] ?? `projects_file_${new Date().getTime()}`

      let blob = new Blob([response.body], { type: type })
      let downloadLink = document.createElement('a')
      downloadLink.href = window.URL.createObjectURL(blob)
      downloadLink.setAttribute('download', fileName)
      document.body.appendChild(downloadLink)
      downloadLink.click()
   }

   // workaround becuause primeng menuItem options has 'id:string' and statutes have id number
   buildMenuItemFromStatutes(statutes?: BasicItemResult[] | null, showLegacy: boolean = true): MenuItem[] {
      let legacyStatutes: any[] = []
      let notLegacyStatutes: any[] = []

      statutes?.forEach((st) => {
         st.legacy ? legacyStatutes.push({ ...st, id: st.id.toString() }) : notLegacyStatutes.push({ ...st, id: st.id.toString() })
      })

      let res: any[] = []

      if (notLegacyStatutes.length) {
         res.push({
            label: showLegacy ? 'Cloud' : null,
            items: [...notLegacyStatutes],
         })
      }

      if (legacyStatutes.length && showLegacy) {
         res.push({
            label: 'Legacy',
            items: [...legacyStatutes],
         })
      }

      return res
   }

   isStatusProposal(status: string | number): boolean {
      return status.toString() === '2'
   }

   isStatusNotGranted(status: string | number): boolean {
      return status.toString() === '10'
   }

   isStatusRunning(status: string | number): boolean {
      return status.toString() === '8'
   }

   isStatusEnded(status: string | number): boolean {
      return status.toString() === '11'
   }

   isStatusInPreparation(status: string | number): boolean {
      return status.toString() === '9'
   }

   isCloudStatus(status: string | number): boolean {
      return this.isStatusProposal(status) || this.isStatusRunning(status) || this.isStatusEnded(status) || this.isStatusNotGranted(status)
   }

   isStatusIdea(status: string | number): boolean {
      return status.toString() === '1'
   }
}
